import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailValidator } from "../../form/validator/email-validator";
import { HttpProductService } from 'src/app/services/http/product.service';
import { ToastService } from 'src/app/services/toast.service';

import { DistinctProductInterfaceType } from "@gea-waldviertler-website/gea-models";

export interface RemindAvailabilityFormFieldsInterface {
  email: string
}

@Component({
    selector: 'gea-shop-remind-availability',
    templateUrl: './remind-availability.component.html',
    styleUrls: ['./remind-availability.component.scss'],
    standalone: false
})
export class RemindAvailabilityComponent {

  @Input() email?: string
  @Input() distinctProduct?: DistinctProductInterfaceType
  @Output("submitRemindRequest") submitRemindRequest = new EventEmitter<any>()

  form: FormGroup
  fb: FormBuilder
  productService: HttpProductService
  toastService: ToastService

  constructor(
    @Inject(HttpProductService) productService: HttpProductService,
    @Inject(ToastService) toastService: ToastService,
    fb: FormBuilder
  ) {
    this.productService = productService
    this.toastService = toastService
    this.fb = fb
    this.form = fb.group({
      email: [this.email, { validators: [EmailValidator.matchValidator] }],
    })
  }

  submit(formValues: RemindAvailabilityFormFieldsInterface) {
    const remindRequest = this.productService.registerRemindAvailibility(formValues.email, this.distinctProduct)
    remindRequest.subscribe((res) => {
      this.toastService.showSuccess("Wir senden eine Nachricht an " + formValues.email + ", sobald wir " + 
        this.distinctProduct?.product?.title + " wieder auf Lager haben.")
    })
    this.submitRemindRequest.emit()
  }

  ngOnInit() {
    if (this.email) {
       this.form.controls['email'].setValue(this.email)
    }
  }

}
